import { render, staticRenderFns } from "./dirGoodsTypeList.vue?vue&type=template&id=654330be&"
import script from "./dirGoodsTypeList.vue?vue&type=script&lang=js&"
export * from "./dirGoodsTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports